import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createRenameReleaseCommand } from '../../../api/commands/factory/createReleaseCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class RenameRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RenameRelease';

    public constructor(public id: string, public name: string, public shouldSendCommand: boolean = true) {
        super(RenameRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RenameRelease): Promise<boolean> => {
    if (!action.shouldSendCommand) {
        return true;
    }

    const release = state.releases.find((x) => x.id === action.id);

    return await useSendCommandAsync(action, {
        createCommand: async () => await createRenameReleaseCommand(action.id, state.id, action.name, release.name),
    });
};

const reducer = (state: StorymapState, action: RenameRelease): void => {
    const release = state.releases.find((x) => x.id === action.id);

    release.name = action.name;
};

//@ts-ignore
registerMiddleware(RenameRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RenameRelease.ACTION_TYPE, reducer);
